module.exports = __webpack_public_path__ + "img/shared6.33ce24a0.png";